import {Component, Input, OnInit} from '@angular/core';
import {BrowseConfig} from "@core/bean/browse-config";
import {CommonsService} from "@core/service/commons.service";
import {SupplyTypeService} from "../../../../routes/jy-srm/basic-data/srm-supply-type/supply-type/supply-type.service";
import {BrowseComponent} from "@shared/components/browse/abstract.browse.component";

@Component({
  selector: 'app-sup-type',
  templateUrl: './sup-type.component.html',
  styles: []
})
export class SupTypeComponent implements BrowseComponent, OnInit {
  static componentName = 'SupTypeBrowserComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;
  visible = false;
  public typeTree:any = [];
  constructor(private commonsService: CommonsService,private supplyTypeService:SupplyTypeService) { }

  ngOnInit() {
    this.visible = true;
    this.getSupplyData();
  }

  getSupplyData(){
    let param:any = {
      sort: 'code,ASC'
    };
    if(this.supplyName){
      param.name = this.supplyName;
    }
    if(this.supplyCode){
      param.code = this.supplyCode;
    }
    this.loading = true;
    this.supplyTypeService.getSupplyAll(param).subscribe((data) => {
      this.typeTree = data;
      this.loading = false;
    }, () => this.loading = false, () => this.loading = false);
  }
  public supplyName:string = "";
  public supplyCode:string = "";
  public loading:boolean = false;
  reset(){
    this.supplyName = "";
    this.supplyCode = "";
  }

  public supply:any = {};
  selectChange(event){
    if(event.nodes.length > 0){
      this.supply = event.node.origin;
    }else{
      this.supply = null;
    }
  }

  //  展开expand
  nzEvent(event): void {
    if (event.eventName === 'expand') {
      if (event.node.isExpanded) {
        event.node.children = [];
        this.supplyTypeService.getSupplyAll({id:event.node.origin.id}).subscribe((data:any) => {
          if(data[0] && data[0].children && data[0].children.length > 0){
            event.node.addChildren(data[0].children);
          }else{
            event.node.isLeaf = true;
            event.node.addChildren([]);
          }
        },() => {event.node.isLeaf = true;event.node.addChildren([])});
      }
    }
  }

  handleCancel(){
    this.visible = false;
    this.onCancel();
  }

  handleOk(){
    if(this.supply && this.supply.id){
      this.onOk(this.supply);
      this.visible = false;
    }else {
      this.commonsService.showWarningMessage('commons.info.selectData');
    }
  }
}
